module.exports = __webpack_public_path__ + "img/bg-carbon-2.d04dde4f.jpg";